import {
  Datatype,
  IReference,
  IReferencePath,
  ReferencePathDirection,
  ReferenceType,
  WidgetType,
} from '@framework/engine';
import { IMapWidget } from '../IMapWidget';
import { MapCadastralAreaSuffix } from '../createMapSchema';

export function getMapWidgetReferences(
  path: IReferencePath,
  widget: IMapWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: Datatype.Array,
      itemsType: Datatype.Object,
      structure: [
        {
          type: ReferenceType.Widget,
          widgetType: WidgetType.Hidden,
          path: [
            ...path,
            { direction: ReferencePathDirection.Child, code: widget.code },
          ],
          id: `${widget.id}@area`,
          code: `area`,
          label: 'Area della Geometria',
          field: {
            type: Datatype.Number,
          },
        },
      ],
    },
  };
}

export function getMapWidgetSiblingReferences(
  path: IReferencePath,
  widget: IMapWidget,
): IReference[] {
  return [
    {
      type: ReferenceType.Widget,
      widgetType: WidgetType.Hidden,
      path: [...path],
      id: `${widget.id}${MapCadastralAreaSuffix}`,
      code: `area`,
      label: 'Totale Area interessata',
      field: {
        type: Datatype.Number,
      },
    },
  ];
}
